<template>
  <form>
    <b-field label="Email">
      <b-input type="email"
               icon="at"
               v-model="email">
      </b-input>
    </b-field>

    <b-field label="Password">
      <b-input type="password"
               v-model="password"
               icon="key"
               password-reveal>
      </b-input>
    </b-field>

    <button class="button is-primary is-medium is-fullwidth"
            :class="{ 'is-loading': isLoading }"
            :disabled="!readyToLogIn"
            @click.prevent="doLogin">
      Log In
    </button>

    <div class="supporting-links">
    <b-checkbox size="is-small" v-model="rememberMe">
      Keep me logged in
      <b-tooltip label="Automatically log in when you come back to Truckl over the next 7 days" position="is-bottom" multilined>
        <font-awesome-icon icon="info-circle" />
      </b-tooltip>
    </b-checkbox>

      <router-link :to="{ 'name': 'password-reset' }" class="help has-text-centered">
        Forgot your password?
      </router-link>
    </div>

    <b-notification class="error-message"
                    type="is-warn"
                    v-show="errorMessage">
      {{ errorMessage }}
    </b-notification>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'FromLogin',

  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
      isLoading: false,
      rememberMe: false
    }
  },

  computed: {
    ...mapGetters('user', ['isFactoring', 'isShipper', 'isCarrier']),
    /**
     * Flag indicating that all info to attempt a log in has been collected
     * @returns {boolean}
     */
    readyToLogIn() {
      return Boolean(this.email.length && this.password.length)
    }
  },

  methods: {
    ...mapActions('user', ['authenticate', 'getDetails']),
    clearErrorMessage() {
      this.errorMessage = ''
    },

    async doLogin() {
      this.clearErrorMessage()
      const data = {
        username: this.email,
        password: this.password,
        keepLoggedIn: this.rememberMe
      }

      try {
        this.isLoading = true
        await this.authenticate(data)
        this.$router.push({ name: 'dashboard' })
      } catch (error) {
        this.isLoading = false
        this.errorMessage = 'Something went wrong. Please check your email+password combination and try again.'
        console.error(error)
      }
    }
  }
}
</script>

<style scoped>
.supporting-links {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.error-message {
  margin-top: 16px;
}
</style>
